import { IChatConfigData } from 'miaw/types/app-interfaces';

export const caDevsConfig: IChatConfigData = {
  locale: 'en-us',
  checkBusinessHour: false,
  sfConfig: {
    orgId: '00D9X00000BCgTN',
    scrt2URL: 'https://vpcare--cadevs.sandbox.my.salesforce-scrt.com/',
    eswConfigDevName: 'Vistaprint_MIAW_EN_SG',
    siteURL: 'https://vpcare--cadevs.sandbox.my.site.com/ESWVistaprintMIAWENSG1736165992087',
    initURL: 'https://vpcare--cadevs.sandbox.my.site.com/ESWVistaprintMIAWENSG1736165992087/assets/js/bootstrap.min.js',
    queueInfo: {
      default: '00G07000000h2Ov',
      checkout: '00G07000000F1Rl',
      design: '00G07000000h8cq',
      digital: '00G07000000h2Ov',
    },
  },
  env: 'sandbox',
};

export const sitConfig: IChatConfigData = {
  locale: 'en-us',
  checkBusinessHour: false,
  sfConfig: {
    orgId: '00D3N000000HG1U',
    scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
    eswConfigDevName: 'Vistaprint_MIAW_EN_SG',
    siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725',
    initURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725/assets/js/bootstrap.min.js',
    queueInfo: {
      default: '00G07000000h2Ov',
      checkout: '00G07000000F1Rl',
      design: '00G07000000h8cq',
      digital: '00G07000000h2Ov',
    },
  },
  env: 'sandbox',
};

export const stConfig: IChatConfigData = {
  locale: 'en-us',
  checkBusinessHour: false,
  sfConfig: {
    orgId: '00D3N000000HG1U',
    scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
    eswConfigDevName: 'Vistaprint_MIAW_EN_SG',
    siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725',
    initURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725/assets/js/bootstrap.min.js',
    queueInfo: {
      default: '00G07000000h2Ov',
      checkout: '00G07000000F1Rl',
      design: '00G07000000h8cq',
      digital: '00G07000000h2Ov',
    },
  },
  env: 'sandbox',
};

export const unifiedSandboxConfig: IChatConfigData = {
  locale: 'en-us',
  checkBusinessHour: false,
  sfConfig: {
    orgId: '00D9V00000EKIn9',
    scrt2URL: 'https://vpcare--unifiedsbx.sandbox.my.salesforce-scrt.com/',
    eswConfigDevName: 'MIAW_Service_Deployment',
    siteURL: 'https://vpcare--unifiedsbx.sandbox.my.site.com/ESWMIAWServiceDeploymen1743755320710',
    initURL:
      'https://vpcare--unifiedsbx.sandbox.my.site.com/ESWMIAWServiceDeploymen1743755320710/assets/js/bootstrap.min.js',
    queueInfo: {
      default: '00G07000000h2Ov',
      checkout: '00G07000000F1Rl',
      design: '00G07000000h8cq',
      digital: '',
    },
  },
  env: 'sandbox',
};
